import React from 'react';
import { FormSubmitBtn } from 'src/buttons';
import { CheckboxField } from 'src/jbc-front/components/Form';
import { useTranslation } from 'react-i18next';
import styles from './SyncCommonIdInsideForm.scss';

const SyncCommonIdInsideForm = ({ handleSubmit, submitting, pristine, submit }) => {
  const { t } = useTranslation();
  return (
    <form onSubmit={handleSubmit}>
      <div className="l-overflow-scroll">
        <table className={styles.table}>
          <thead>
            <tr>
              <th>{t('features.Coordinations.components.SyncCommonIdInsideForm.service_name')}</th>
              <th>{t('features.Coordinations.components.SyncCommonIdInsideForm.jobcan_common_name')}</th>
              <th>{t('features.Coordinations.components.SyncCommonIdInsideForm.jobcan_common_staff_code')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{t('features.Coordinations.components.SyncCommonIdInsideForm.jobcan_common_id')}</td>
              <td><CheckboxField name="isSyncCommonIdName" label={t('features.Coordinations.components.SyncCommonIdInsideForm.integrate')} /></td>
              <td><CheckboxField name="isSyncCommonIdStaffCode" label={t('features.Coordinations.components.SyncCommonIdInsideForm.integrate')} /></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="u-ta-c u-mt20">
        <FormSubmitBtn text={t('features.Coordinations.components.SyncCommonIdInsideForm.save')} disabled={submitting || pristine} {...{ submitting, submit}} />
      </div>
    </form>
  );
};

export default SyncCommonIdInsideForm;
